var _circle, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _circle2, _g, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetFanLinkCampaign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 123,
    viewBox: "0 0 240 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 63,
    r: 41,
    fill: "#1B0076"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4584 64.7105L29.0416 68.1273L22.2081 61.2937C17.4905 56.5762 17.4905 48.9275 22.2081 44.2099C26.9257 39.4923 34.5743 39.4923 39.2919 44.2099L46.1255 51.0434L42.7087 54.4602L35.8752 47.6267C33.0446 44.7961 28.4554 44.7961 25.6248 47.6267C22.7943 50.4572 22.7943 55.0464 25.6248 57.877L32.4584 64.7105ZM49.5422 61.2957L52.959 57.8789L59.7925 64.7124C64.5101 69.43 64.5101 77.0787 59.7925 81.7963C55.0749 86.5139 47.4262 86.5139 42.7087 81.7963L35.8751 74.9628L39.2919 71.546L46.1254 78.3795C48.956 81.2101 53.5452 81.2101 56.3758 78.3795C59.2063 75.549 59.2063 70.9598 56.3758 68.1292L49.5422 61.2957ZM34.166 52.75L30.7492 56.1668L47.8331 73.2506L51.2499 69.8338L34.166 52.75Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 165,
    width: 74.4613,
    height: 122.848,
    rx: 6.72033,
    fill: "#1B0076"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 169.301,
    y: 90.3242,
    width: 65.0528,
    height: 26.0749,
    rx: 3.22576,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 176.292,
    y: 94.3587,
    width: 50.8057,
    height: 6.45152,
    rx: 1.07525,
    stroke: "#CACACA",
    strokeWidth: 0.537627
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 176.023,
    y: 103.496,
    width: 51.3433,
    height: 6.98914,
    rx: 3.49457,
    fill: "#1B0076"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 169.301,
    y: 45.9648,
    width: 65.0528,
    height: 40.322,
    rx: 3.22576,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 176.023,
    y: 67.7376,
    width: 4.83864,
    height: 4.83864,
    rx: 1.07525,
    stroke: "#CACACA",
    strokeWidth: 0.537627
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 176.023,
    y: 59.6751,
    width: 4.83864,
    height: 4.83864,
    rx: 1.07525,
    stroke: "#CACACA",
    strokeWidth: 0.537627
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 176.023,
    y: 75.8079,
    width: 4.83864,
    height: 4.83864,
    rx: 1.07525,
    stroke: "#CACACA",
    strokeWidth: 0.537627
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 175.754,
    y: 52.418,
    width: 51.6121,
    height: 3.49457,
    rx: 1.74729,
    fill: "#1B0076"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 169.301,
    y: 13.9805,
    width: 65.0528,
    height: 28.4942,
    rx: 3.22576,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 175.754,
    y: 27.6914,
    width: 52.6874,
    height: 3.49457,
    rx: 1.74729,
    fill: "#CACACA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 175.754,
    y: 32.7969,
    width: 37.2865,
    height: 3.49457,
    rx: 1.74729,
    fill: "#CACACA"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 183.547,
    y: 60.4883,
    width: 37.365,
    height: 2.68813,
    rx: 1.34407,
    fill: "#CACACA"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 183.547,
    y: 69.0898,
    width: 25.8061,
    height: 2.68813,
    rx: 1.34407,
    fill: "#CACACA"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 183.547,
    y: 76.8828,
    width: 33.3328,
    height: 2.68813,
    rx: 1.34407,
    fill: "#CACACA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_72285",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 5,
    width: 19,
    height: 18
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.338,
    cy: 14.1114,
    r: 8.73643,
    fill: "#EF2D2D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_72285)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.602,
    y: 4.03125,
    width: 29.8383,
    height: 20.161,
    fill: "#AFA3D8"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3567 59.6449C95.6083 60.0002 95.2897 60.8949 95.6449 61.6433C96.0002 62.3917 96.8949 62.7103 97.6433 62.3551L96.3567 59.6449ZM97 61C97.6433 62.3551 97.6431 62.3552 97.6429 62.3553C97.6429 62.3552 97.6427 62.3553 97.6427 62.3553C97.6428 62.3553 97.643 62.3552 97.6433 62.355C97.6441 62.3547 97.6457 62.3539 97.648 62.3528C97.6526 62.3507 97.6602 62.3471 97.6708 62.3422C97.692 62.3323 97.7252 62.3169 97.7699 62.2964C97.8594 62.2554 97.9952 62.194 98.1745 62.115C98.5332 61.9571 99.0658 61.7292 99.7501 61.4546C101.119 60.905 103.092 60.1698 105.492 59.4341C110.303 57.9591 116.771 56.5 123.5 56.5V53.5C116.368 53.5 109.586 55.0409 104.612 56.5659C102.119 57.3302 100.066 58.095 98.6326 58.6704C97.9154 58.9583 97.3523 59.1991 96.9657 59.3693C96.7724 59.4545 96.6231 59.5219 96.5207 59.5688C96.4695 59.5923 96.43 59.6106 96.4025 59.6234C96.3888 59.6298 96.3781 59.6348 96.3705 59.6385C96.3666 59.6403 96.3636 59.6417 96.3613 59.6428C96.3601 59.6433 96.3592 59.6438 96.3584 59.6441C96.358 59.6443 96.3576 59.6445 96.3574 59.6446C96.357 59.6448 96.3567 59.6449 97 61ZM123.5 56.5C130.229 56.5 136.697 57.9591 141.508 59.4341C143.908 60.1698 145.881 60.905 147.25 61.4546C147.934 61.7292 148.467 61.9571 148.825 62.115C149.005 62.194 149.141 62.2554 149.23 62.2964C149.275 62.3169 149.308 62.3323 149.329 62.3422C149.34 62.3471 149.347 62.3507 149.352 62.3528C149.354 62.3539 149.356 62.3547 149.357 62.355C149.357 62.3552 149.357 62.3553 149.357 62.3553C149.357 62.3553 149.357 62.3552 149.357 62.3553C149.357 62.3552 149.357 62.3551 150 61C150.643 59.6449 150.643 59.6448 150.643 59.6446C150.642 59.6445 150.642 59.6443 150.642 59.6441C150.641 59.6438 150.64 59.6433 150.639 59.6428C150.636 59.6417 150.633 59.6403 150.63 59.6385C150.622 59.6348 150.611 59.6298 150.597 59.6234C150.57 59.6106 150.53 59.5923 150.479 59.5688C150.377 59.5219 150.228 59.4545 150.034 59.3693C149.648 59.1991 149.085 58.9583 148.367 58.6704C146.934 58.095 144.881 57.3302 142.388 56.5659C137.414 55.0409 130.632 53.5 123.5 53.5V56.5Z",
    fill: "#1B0076"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.847 62.074C154.315 62.6855 153.945 63.5739 153.182 63.673L142.444 65.0678C141.681 65.167 141.096 64.4026 141.392 63.6919L145.553 53.6954C145.849 52.9848 146.803 52.8608 147.271 53.4723L153.847 62.074Z",
    fill: "#1B0076"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetFanLinkCampaign);
export default __webpack_public_path__ + "static/media/set-fan-link-campaign.92417075.svg";
export { ForwardRef as ReactComponent };